module.exports = __webpack_public_path__ + "static/media/LK_Modify-Edit.6d5a50e2.svg";